const Violet = {
    title: 'Violet',
    background: 'radial-gradient(circle, #a68adb 0%, #8766c4 100%)',
    colors: {
        primary: '#8766c4',
        secondary: '#9879d1',
        terciary: '#a68adb',
        fourth: '#e6dcf2',
        fifth: '#f9f5ff'
    }
};

export default Violet;